export default async function(context) {
  if (!context.$auth.loggedIn && context.query.school === 'staugustineday') {
    context.redirect('/staugustinesday');
  }
}
